import {
    NON_ISSUE_READY_GOODS_GRAY_STOCK_REPORT_REQUEST,
    NON_ISSUE_READY_GOODS_GRAY_STOCK_REPORT_SUCCESS,
    NON_ISSUE_READY_GOODS_GRAY_STOCK_REPORT_FAILURE,
    NON_ISSUE_READY_GOODS_GRAY_STOCK_FILTER_REPORT_REQUEST,
    NON_ISSUE_READY_GOODS_GRAY_STOCK_FILTER_REPORT_SUCCESS,
    NON_ISSUE_READY_GOODS_GRAY_STOCK_FILTER_REPORT_FAILURE,
  } from "../types/non-issue-ready-goods-gray-stock-report-types";
  
  const initialState = {
    nonIssueReadyGoodsGrayStockReport: {},
    nonIssueReadyGoodsGrayStockFilterReport: {},
    loading: false,
    error: null,
  };
  
  const nonIssueReadyGoodsGrayStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case NON_ISSUE_READY_GOODS_GRAY_STOCK_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case NON_ISSUE_READY_GOODS_GRAY_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case NON_ISSUE_READY_GOODS_GRAY_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          nonIssueReadyGoodsGrayStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case NON_ISSUE_READY_GOODS_GRAY_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          nonIssueReadyGoodsGrayStockFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case NON_ISSUE_READY_GOODS_GRAY_STOCK_REPORT_FAILURE, NON_ISSUE_READY_GOODS_GRAY_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default nonIssueReadyGoodsGrayStockReportReducer;
  